import { SvgTypesProps } from '@/shared/types/SvgTypes';

export function IconSuccess({
  fill = 'var(--sapphire-20)',
  width = 24,
  height = 24,
}: SvgTypesProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="8" fill="#4FBB82"/>
      <path d="M8 12L11 15L17 9" stroke="white" strokeWidth="1.5" strokeLinejoin="round"/>
    </svg>
  );
}
